
import { computed, defineComponent } from "vue";
import { useStore } from "@/store";
import { authService } from "@/services";
import { AddressMode } from "@/libs/address";

export default defineComponent({
  name: "AddressModeToggle",
  setup() {
    const store = useStore();
    const mode = computed(() => store.state.main.addressMode);
    // Danh mục 2 cấp mới chỉ áp dụng cho J&T, BEST vẫn dùng danh mục GHTK
    const visible = authService.getUserInfoLocal()?.shippingCode !== "BEST";

    const setMode = (value: AddressMode) => {
      store.commit("main/SET_ADDRESS_MODE", value);
    };

    return { mode, visible, setMode };
  },
});
